import React, { useContext } from 'react';
import { usePrivacy } from '../contexts/PrivacyContext';

interface SensitiveValueProps {
  children: React.ReactNode;
  className?: string;
  preserveLayout?: boolean;
}

const SensitiveValue: React.FC<SensitiveValueProps> = ({ 
  children, 
  className = '',
  preserveLayout = true 
}) => {
  // Verificar se estamos no dashboard público
  const isPublicDashboard = window.location.pathname.includes('/public/');
  
  // Sempre chamar o hook do contexto de privacidade
  const { valuesHidden } = usePrivacy();
  
  // No dashboard público, sempre ocultar valores
  const shouldHide = isPublicDashboard || valuesHidden;

  if (!shouldHide) {
    return <>{children}</>;
  }

  // Se preserveLayout é true, substituir o conteúdo por valor falso padrão
  if (preserveLayout) {
    return (
      <span 
        className={`${className} select-none`}
        style={{ filter: 'blur(6px)', userSelect: 'none' as const }}
        title="Valor oculto por privacidade"
      >
        9999.99
      </span>
    );
  }

  // Se preserveLayout é false, mostrar pontos
  return (
    <span 
      className={`${className} select-none`}
      title="Valor oculto por privacidade"
    >
      ••••••
    </span>
  );
};

export default SensitiveValue;
